import Immutable, { Record } from 'immutable';

const SkillAbilityRecord = Record({
  id: undefined,
  name: undefined,
  point: undefined,
});

class SkillAbility extends SkillAbilityRecord { }

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'id':
      return [key, `${val}`];
    case 'point':
      return [key, `${val}`];
    default:
      return [key, Immutable.fromJS(val)];
  }
};

SkillAbility.create = (data) =>
  new SkillAbility(data).mapEntries(reviver);

export default SkillAbility;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/OverallDevelopment/template/skills/abilities/model.js